import { FC } from 'react';
import { Typography } from 'antd';

import { WPMenuItem } from 'models';

import styles from './index.module.scss';

type Content = { content?: string };
type Menu = { menu?: WPMenuItem[] };
type Required = { title: string };

type FooterColumnProps = Required & Content & Menu;

export const FooterColumn: FC<FooterColumnProps> = (data) => {
	return (
		<div className={styles.column}>
			<Typography.Title level={5} className={styles.title}>
				{data.title}
			</Typography.Title>
			{data.content && <div dangerouslySetInnerHTML={{ __html: data.content }} />}

			{data.menu?.map((item) => (
				<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
					{item.title}
				</a>
			))}
		</div>
	);
};
